<template>
	<div>
		<el-card class="box-card">
			<span>账户余额：
				<span style="color:#F56C6C">{{balance.rmb}}</span>（人民币）
				<span v-show="is_show_th"><span style="color:#F56C6C;margin-left: 20px;">{{balance.th}}</span>（泰铢）</span>
				<span v-show="is_show_ph"><span style="color:#F56C6C;margin-left: 20px;">{{balance.ph}}</span>（比索）</span>
			</span>
		</el-card>
		<el-card class="box-card">
			<el-form label-width="80px" :inline="true">
				<el-form-item label="交易类型:">
					<el-select v-model="listQuery.search.sign" placeholder="请选择">
						<el-option label="全部" value=""></el-option>
						<el-option label="支出" value="0"></el-option>
						<el-option label="收入" value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="店铺">
					<el-select v-model="listQuery.search.shop_id" filterable clearable placeholder="全部">
						<el-option v-for="item in store_all" :key="item.id" :label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-show="is_show_out_select" label="币种">
					<el-col :span="24" style="margin-left: 5px;">
						<el-select v-model="listQuery.search.currency_type" placeholder="请选择">
							<el-option label="全部" value=""></el-option>
							<el-option v-for="item in currency" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-col>
				</el-form-item>
				<el-form-item label="日期:">
					<el-date-picker v-model="listQuery.search.start_time" type="date" placeholder="开始日期">
					</el-date-picker>
					-
					<el-date-picker v-model="listQuery.search.end_time" type="date" placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
			</el-form>
			<el-button type="primary" icon="el-icon-search" @click="keySearch">搜索</el-button>
			<el-button type="success" style="margin-left:150px;" plain @click="excel" icon="el-icon-download">导出数据</el-button>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column prop="create_time" label="日期">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="type_init" label="类型"></el-table-column>
				<el-table-column prop="store_name" label="店铺"></el-table-column>
				<el-table-column prop="currency_type_init" label="币种"></el-table-column>
				<el-table-column prop="money" label="金额">
					<template slot-scope="{row}">
						<span v-if="row.sign == 1" style="color:#67C23A">+ {{row.money}}</span>
						<span v-else style="color:#F56C6C">- {{row.money}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="balance" label="账户余额"> </el-table-column>
				<el-table-column prop="remarks" label="备注"> </el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
		</div>
	</div>
</template>

<script>
	import {
		brListInit,
		brList,
		excelToken
	} from '@/api/jd_task'
	import {
		getToken,
	} from '@/tool/cookie'
	import request from '@/tool/request'
	import {
		parseTime
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import Dtp from '@/components/Ele/dateTimePicker.vue' // 时间选择组件
	export default {
		components: {
			Pagination,
			Dtp
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
				is_show_in1: false,
				in1_data: [],
				is_show_in2: false,
				in2_data: [],
				is_show_collocation: false,
				collocation_data: [],
				platform_list: [],
				state_all: [],
				balance:{
					rmb:'0.00',
					th:'0.00',
					ph:'0.00',
				},
				is_show_th:false, // 是否显示泰铢
				is_show_ph:false, // 是否显示比索
				currency:[], // 所有币种
				store_all:[], // 所有店铺
			};
		},
		// 计算属性
		computed:{
			// 是否显示币种筛选
			is_show_out_select:function(){
				return (this.is_show_th) || (this.is_show_ph);
			}
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.brListInit();
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						sign: '',
						currency_type:'',
						start_time: '',
						end_time: '',
					},
				}
			},
			brListInit() {
				brListInit(Qs.stringify(this.listQuery)).then(response => {
					let r = response.result;
					this.balance = {
						rmb:r.balance.rmb,
						th:r.balance.th,
						ph:r.balance.ph,
					};
					
					this.currency = r.currency;
					
					let ct = r.ct;
					this.is_show_th = ct.is_show_th;
					this.is_show_ph = ct.is_show_ph;
					this.store_all = r.shop_all;
				})
			},
			getList() { // 获取列表数据
				this.loading = true;
				brList(Qs.stringify(this.listQuery)).then(response => {
					this.data_list = response.result.items;
					this.total = response.result.total;
					this.loading = false;
				})
			},
			platformChange() {
				this.keySearch();
			},
			stateChange() {
				this.keySearch();
			},
			excel() {
				// 获取exceltoken
				excelToken(Qs.stringify()).then(response => {
					let token = response.result.token;
					if (token) {
						let xid = getToken('login_uid');
						let search = JSON.stringify(this.listQuery.search);
						window.open(process.env.VUE_APP_ADMIN_BASE_URL + "/TaskExcel/brDetails?xid=" + xid +
							"&token=" + token + '&search=' + search,
							"_blank");
					}
				})
			}
		}
	}
</script>
<style>
	.el-radio {
		margin-right: 0px;
	}
</style>
